import { Model, belongsTo } from 'miragejs'

export default Model.extend({
  teacher: belongsTo(),
  subscriptionUtilisation: belongsTo(),
})
